import "./Header.css";

import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import API from "../../../services/api";
import useCurrentLocation from "../../../hooks/useCurrentLocation";

import {
  FaMapMarkerAlt,
  FaChevronDown,
  FaUserCircle,
  FaBoxOpen,
  FaHeart,
  FaGift,
  FaCog,
  FaSearch,
} from "react-icons/fa";

function Header() {

  const navigate = useNavigate();

  const [showProfileMenu, setShowProfileMenu] =
    useState(false);

  const [unreadCount, setUnreadCount] =
    useState(0);
    const [userName, setUserName] = useState("");

  const profileRef = useRef(null);

  const {
    address,
    loading,
    error,
  } = useCurrentLocation();

  // ==========================
  // Fetch Notification Count
  // ==========================

  const loadUnreadCount = async () => {

    try {

      const res = await API.get(
        "/user-notifications/unread-count"
      );

      if (res.data.success) {

        setUnreadCount(
          res.data.unreadCount || 0
        );

      }

    } catch (err) {

      console.log(err);

    }

  };
  // ==========================
// Fetch Customer Profile
// ==========================

const loadUserProfile = async () => {

    try {

        const res = await API.get("/users/profile");

        console.log("👤 Customer Profile:", res.data);

        if (res.data.success) {

            setUserName(
                res.data.user?.name ||
                res.data.profile?.name ||
                "Customer"
            );

        }

    } catch (err) {

        console.log(
            "❌ Failed to load customer profile:",
            err
        );

        setUserName("Customer");

    }

};

 useEffect(() => {

    loadUnreadCount();
    loadUserProfile();

    const interval = setInterval(
        loadUnreadCount,
        30000
    );

    return () => clearInterval(interval);

}, []);

  // ==========================
  // Close Profile Menu
  // ==========================

  useEffect(() => {

  function handleClickOutside(e) {

    if (
      profileRef.current &&
      !profileRef.current.contains(e.target)
    ) {
      setShowProfileMenu(false);
    }

  }

  document.addEventListener(
    "click",
    handleClickOutside
  );

  return () =>
    document.removeEventListener(
      "click",
      handleClickOutside
    );

}, []);

  return (

    <header className="hf-header">

      {/* ==========================
              TOP BAR
      ========================== */}

      <div className="hf-top">

        {/* Logo */}

        <div className="hf-logo">

          <img
            src="/images/logo.png"
            alt="HomeFoods"
            className="hf-logo-img"
          />

        </div>

        {/* Actions */}

        <div className="hf-actions">

          {/* Notification */}

          <button

            className="hf-notification"

            onClick={() =>
              navigate("/customer/notifications")
            }

          >

            🔔

            {

              unreadCount > 0 && (

                <span className="notification-badge">

                  {unreadCount}

                </span>

              )

            }

          </button>

          {/* Profile */}

          <div

            className="hf-profile-wrapper"

            ref={profileRef}

          >

            <button
  className="hf-profile"
  onClick={(e) => {
    e.stopPropagation();
    setShowProfileMenu(!showProfileMenu);
  }}
>
  👤
</button>

            {

              showProfileMenu && (

                <div
  className="profile-menu"
  onClick={(e) => e.stopPropagation()}
>

                  <div className="profile-user">

                    <FaUserCircle />

                    <div>

                      <h4>

                        {userName}

                      </h4>

                      <span>

                        Customer

                      </span>

                    </div>

                  </div>

                  <hr />

                  <button
                    onClick={() => {

                      setShowProfileMenu(false);

                      navigate("/my-orders");

                    }}
                  >

                    <FaBoxOpen />

                    My Orders

                  </button>

                  <button
                    onClick={() => {

                      setShowProfileMenu(false);

                      navigate("/favorites");

                    }}
                  >

                    <FaHeart />

                    Favorites

                  </button>

                  <button>

                    <FaGift />

                    Coupons & Offers

                  </button>

                  <button
                    onClick={() => {

                      setShowProfileMenu(false);

                      navigate("/settings");

                    }}
                  >

                    <FaCog />

                    Settings

                  </button>

                </div>

              )

            }

          </div>

        </div>

      </div>

      {/* ==========================
              SEARCH BAR
      ========================== */}

     

           {/* ==========================
              LOCATION
      ========================== */}

      <div className="hf-location-card">

        <div className="hf-location-left">

          <div className="location-icon">

            <FaMapMarkerAlt />

          </div>

          <div>

            <span className="location-label">

              Delivering To

            </span>

            {

              loading ? (

                <h3>

                  Fetching Location...

                </h3>

              ) : error ? (

                <h3>

                  Location Unavailable

                </h3>

              ) : (

                <h3>

                  {address}

                </h3>

              )

            }

          </div>

        </div>

        <FaChevronDown className="location-arrow" />

      </div>

      {/* ==========================
              HERO SECTION
      ========================== */}

      <div className="hf-hero">

        <span className="hero-chip">

          🍴 Trusted Home Chefs & Restaurants

        </span>

        <h1>

          Fresh. Homemade. Delivered.

        </h1>

        <p>

          Healthy • Hygienic • Delicious

        </p>

      </div>

    </header>

  );

}

export default Header;